/* @flow */
import * as React from 'react';
import { translate } from 'react-i18next';
import { Link } from 'react-router-dom';
import { observer } from 'mobx-react';
import Moment from 'react-moment';

import type { TranslatorProps } from 'react-i18next';

import ListItem from '@material-ui/core/ListItem';

import { getNotificationCopy } from 'utils/NotificationUtils';

import styles from './NotificationTableItem.module.scss';

type TypeProps = {|
  notification: Object,
|} & TranslatorProps;

@translate()
@observer
export default class NotificationTableItem extends React.Component<*> {
  render(): React.Element<*> {
    const { t, notification }: TypeProps = this.props;
    const eventCategory: string = notification.event_category.toLowerCase();
    const titleCopyInfo = getNotificationCopy(notification, 'Title');
    const bodyCopyInfo = getNotificationCopy(notification, 'Body');

    return (
      <Link to={`/notifications/${notification.event_id}`}>
        <ListItem button={true} className={styles['noti-table-item']}>
          <div className={styles['noti-item-icon']}>
            <svg>
              <use xlinkHref="#icon-assets" />
            </svg>

            {eventCategory === 'approved' ? (
              <svg className={`${styles['status-icon']} ${styles['status-approved']}`}>
                <use xlinkHref="#icon-approve" />
              </svg>
            ) : eventCategory === 'request' ? (
              <svg className={`${styles['status-icon']} ${styles['status-requested']}`}>
                <use xlinkHref="#icon-notification-action" />
              </svg>
            ) : eventCategory === 'warning' || eventCategory === 'declined' ? (
              <svg className={`${styles['status-icon']} ${styles['status-error']}`}>
                <use xlinkHref="#icon-error" />
              </svg>
            ) : eventCategory === 'info' ? (
              <svg className={`${styles['status-icon']} ${styles['status-info']}`}>
                <use xlinkHref="#icon-information" />
              </svg>
            ) : null}
          </div>

          <div className={styles['noti-item-desc']}>
            <div className={styles['desc-top-line']}>
              <span>
                {t(titleCopyInfo.key, {
                  ...notification,
                  ...notification.template_values,
                  ...titleCopyInfo.options,
                })}
              </span>
              <small>
                <Moment date={notification.created_at} format="MMMM DD, YYYY - hh:mm a" />
              </small>
            </div>
            <div className={styles['desc-bottom-line']}>
              {t(bodyCopyInfo.key, {
                ...notification,
                ...notification.template_values,
                ...bodyCopyInfo.options,
              })}
            </div>
          </div>

          <div>
            <svg className={styles['view-icon']}>
              <use xlinkHref="#icon-chevron-down" />
            </svg>
          </div>
        </ListItem>
      </Link>
    );
  }
}
